import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import { getReplenishLink } from 'utils';

import { AccumulatorProgress } from './components/AccumulatorProgress';
import { Count } from './components/Count';
import { AccumulatorType } from '../../../types';
import styles from './styles.pcss';
import { TITLE_DICTIONARY } from './components/constants';

const cn = classNames.bind(styles);

export const Accumulator: FC<AccumulatorType> = ({
  description,
  displayUnit,
  isUnlimited,
  isLow,
  rest,
  size,
  unit,
  replenishButtonType,
  buyTrafficText,
  tariffUrl,
  fallbackUrl,
  fallbackText,
}) => (
  <div>
    <div className={cn('title')}>
      <Text size="size5-m">{TITLE_DICTIONARY[unit]}</Text>
    </div>
    {!rest ?
      <Text color="contentAccent1" size="size5-m">
        <a href={fallbackUrl}>{fallbackText}</a>
      </Text>
    : <Count
        className={cn('count')}
        description={description}
        displayUnit={displayUnit}
        isLow={isLow}
        isUnlimited={isUnlimited}
        rest={rest}
        size={size}
      />
    }
    {size && (
      <AccumulatorProgress isLow={isLow} isUnlimited={isUnlimited} rest={rest} size={size} />
    )}
    {replenishButtonType && (
      <div className={cn('mar-t-xs', 'replenish-button')}>
        <Text color="contentAccent1" size="size5-m">
          <a href={getReplenishLink(replenishButtonType, tariffUrl)}>{buyTrafficText}</a>
        </Text>
      </div>
    )}
  </div>
);
